import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';

import { Loader } from '@hivebrite/design-system/Loader';

import { type Event } from 'hb-react/shared/apps/Events';
import { ZoomMeeting } from 'hb-react/shared/apps/Zoom/components/ZoomMeeting';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const EventZoomMeeting = ({
  event,
  leaveUrl,
}: {
  event: Event;
  leaveUrl: string;
}) => {
  const { data: meetingData, isLoading: isLoadingMeetingData } = useQuery({
    queryKey: ['zoom-signature', 'event', event.id],
    queryFn: () =>
      axios.get(Routes.zoom_signature_path({ eventId: event.id })).then(
        ({
          data: {
            signature,
            meetConfig: {
              meetingNumber,
              passWord,
              userName,
              userEmail,
              customerKey,
              sdkKey,
            },
          },
        }) => ({
          signature,
          meetingNumber,
          passWord,
          userName,
          userEmail,
          customerKey,
          sdkKey,
        }),
      ),
  });

  if (isLoadingMeetingData) {
    return <Loader />;
  }

  if (!meetingData) {
    return <Navigate to={leaveUrl} />;
  }

  return (
    <ZoomMeeting
      title={event.title}
      leaveUrl={leaveUrl}
      meetingData={meetingData}
    />
  );
};
